module.exports = __webpack_public_path__ + "img/honor6.e4835ce5.jpg";